module.exports = __webpack_public_path__ + "static/media/bhim_icon.2cc3d35b.png";